// Libs
import classNames from 'classnames/bind';
import { Box, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
import { IJobItemSlip } from '~/utils/interface/order';
// Styles, images, icons
import styles from './ItemPartOrder.module.scss';

type Props = {
  item: IJobItemSlip;
};

const cx = classNames.bind(styles);

const ItemPartOrder = (props: Props) => {
  //#region Destructuring Props
  const { item } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='itemPartOrderComponent' className={cx('container')}>
      <Typography className={cx('title')}>{item?.title}</Typography>
      <Typography className={cx('description')}>{item?.variantName}</Typography>
    </Box>
  );
};

export default ItemPartOrder;
